module.exports = __webpack_public_path__ + "media/src/img/payment/Frame7-31340ff89688761351dd2569a79108bb.svg";